import ConfirmModal from "PFComponents/confirm/confirm_modal";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  onClose: () => void;
  onSubmit: () => void;
};

const SetHierarchicalListModal = ({ onClose, onSubmit }: Props) => {
  const { t } = useTranslation(["admin", "translation"]);

  return (
    <ConfirmModal
      handleOK={onSubmit}
      handleClose={onClose}
      handleCancel={onClose}
      labelOK={t("translation:continue")}
      title={t("admin:customFields.hierarchical.setListModal.title")}
    >
      {t("admin:customFields.hierarchical.setListModal.description")}
    </ConfirmModal>
  );
};

export default SetHierarchicalListModal;
